"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/Grid/types");
const Error_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Error/Error.png"));
const Ok_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Ok/Ok.png"));
const Starting_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Starting/Starting.png"));
const Warning_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Warning/Warning.png"));
const Running_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Running/Running.png"));
const Pending_png_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Pending/Pending.png"));
const Refresh_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/common/Refresh/Refresh.svg"));
const Info_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Info/Info.svg"));
const Cancelled_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Cancelled/Cancelled.svg"));
const neverExecuted_svg_1 = __importDefault(require("../../../assets/icons/neverExecuted.svg"));
const stopped_svg_1 = __importDefault(require("../../../assets/icons/stopped.svg"));
const constants_1 = require("../../../constants");
require("../../../core");
const helpers_1 = require("../../../helpers");
const Layouts_1 = require("../Layouts");
require("../types");
const getStatusIcon = (status) => {
    let iconSrc = '';
    switch (status) {
        case 'success':
        case 'succeeded':
        case 'passed':
            iconSrc = Ok_png_1.default;
            break;
        case 'warning':
            iconSrc = Warning_png_1.default;
            break;
        case 'error':
        case 'failed':
        case 'failure':
            iconSrc = Error_png_1.default;
            break;
        case 'cancelled':
            iconSrc = Cancelled_svg_1.default;
            break;
        case 'starting':
            iconSrc = Starting_png_1.default;
            break;
        case 'stopped':
        case 'stopping':
            iconSrc = stopped_svg_1.default;
            break;
        case 'running':
            iconSrc = Running_png_1.default;
            break;
        case 'pending':
            iconSrc = Pending_png_1.default;
            break;
        case 'neverexecuted':
            iconSrc = neverExecuted_svg_1.default;
            break;
        case 'checking':
            iconSrc = Refresh_svg_1.default;
            break;
        case 'info':
        case 'notconfigured':
        case 'verificationneeded':
            iconSrc = Info_svg_1.default;
            break;
        default:
            iconSrc = '';
    }
    return iconSrc;
};
function statusCellRenderer({ action, showLink = false, emptyValue = constants_1.EMPTY_TEXT.dash, customIconSrc, } = {}) {
    return function cellRenderer(_a) {
        var { cellData, rowData, disabled } = _a, otherProps = __rest(_a, ["cellData", "rowData", "disabled"]);
        const status = (cellData && cellData.toLowerCase()) || '';
        const iconSrc = customIconSrc || getStatusIcon(status);
        const text = helpers_1.camelSplit(cellData || '') || emptyValue;
        return (react_1.default.createElement(Layouts_1.TruncatedText, null,
            iconSrc && (react_1.default.createElement(Layouts_1.TooltipIconWrapper, null,
                react_1.default.createElement(Layouts_1.CellIcon, { "data-selector-id": "status-cell-icon", src: iconSrc, disabled: disabled }))),
            react_1.default.createElement(Layouts_1.TooltipTextWrapper, { withIcon: !!iconSrc }, showLink && !disabled ? (react_1.default.createElement(components_1.Link, { "data-selector-id": "status-cell-link", onClick: (e) => {
                    e.preventDefault();
                    action === null || action === void 0 ? void 0 : action({ rowData });
                } }, react_1.default.createElement(Layouts_1.LinkTextWrapper, null, components_1.textCellRenderer(Object.assign({ cellData: text, rowData }, otherProps))))) : (components_1.textCellRenderer(Object.assign({ cellData: text, disabled, rowData }, otherProps))))));
    };
}
exports.statusCellRenderer = statusCellRenderer;
//# sourceMappingURL=statusCellRenderer.js.map